import React from "react";
import "./prize-info.scss";

interface IProps {
  points: string;
  title: string;
}

const PrizeInfo = (props: IProps) => {

  return (
    <div id="prize-info">
      <div className="points">{props.points}</div>
      <div className="points-text">{props.title}</div>
    </div>
  );
}

export default PrizeInfo;
